import Dialog from '@material-ui/core/Dialog';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

const StyledDialog = styled(Dialog)`
  & > .MuiDialog-container > .MuiPaper-root {
    width: 100%;
  }
`;

const tableStyles = makeStyles((theme) => ({
  root: {
    margin: '10px 0',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export { StyledDialog, tableStyles };
